var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.383,
    height: 21.797,
    viewBox: "0 0 11.383 21.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M87.387,21.8v-9.93h3.391l.484-3.875H87.387V5.57c0-1.09.363-1.938,1.938-1.938h2.059V.121C90.9.121,89.688,0,88.356,0c-2.906,0-4.965,1.816-4.965,5.086V7.992H80v3.875h3.391V21.8Z",
    transform: "translate(-80)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.97ef70d492749b763d9aba482ea3c0ee.svg";
export { ForwardRef as ReactComponent };